import { NavLink } from "react-router-dom";

function MenuItem({ icon, text, to, collapsed = false }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `
        flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-200
        ${
          isActive
            ? "bg-orange-600 text-white shadow-md"
            : "text-gray-200 hover:bg-blue-800 hover:text-white"
        }
        ${collapsed ? "justify-center" : ""}
      `
      }
    >
      {icon}
      {!collapsed && <span className="text-sm">{text}</span>}
    </NavLink>
  );
}

export default MenuItem;
